import React from "react";
import { SalesStatus } from "../../../interfaces/enums";
import { AlertContent, ProductColor, ProductDetailResponse } from "../../../interfaces/interfaces";
import { ColorSizeStock } from "../interfaces";

export const AU_LOCATIONS = [
  { name: "Melbourne", regionID: "MEL" },
  { name: "Perth", regionID: "PER" },
  { name: "Sydney", regionID: "SYD" },
];

export const QTY_CAPPED_STATUSES = [
  SalesStatus.Discontinued,
  SalesStatus.LimitedStock,
  SalesStatus.Clearance,
];

export const BACK_ORDER_EXCLUDED_STATUSES = [SalesStatus.Clearance, SalesStatus.Discontinued];

export interface SizeStockProps {
  shouldRenderSizeDetail: boolean;
  currentSelectedColor: ProductColor;
  currentColorSizeStocks: ColorSizeStock[];
  setCurrentColorSizeStocks: React.Dispatch<React.SetStateAction<ColorSizeStock[]>>;
  itemPrice: string | undefined;
  setActionStatus: React.Dispatch<React.SetStateAction<AlertContent | null>>;
  product: ProductDetailResponse;
  inputRefs: any;
  setInputRefs: any;
}
